import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Login from '@features/loginPage/components/Login/Login';
import styles from '@components/CreativeModalContent/CreativeModalLogin.style';
import { LOGIN_PAGE_TYPES } from '@features/loginPage/const';
type PropsType = {
  uuId: string;
  imageUrl: string;
};
const CreativeModalLogin = ({
  uuId,
  imageUrl
}: PropsType) => {
  const {
    asPath
  } = useRouter();
  const [fullpath, fullpathSet] = useState('');
  useEffect(() => {
    fullpathSet(`${window.location.pathname}?objectUuid=${uuId}&saveCreative=true&imageUrl=${imageUrl}`);
  }, [asPath, uuId, imageUrl]);
  return <div sx={styles.loginModal}>
      <div sx={styles.loginOverflow}>
        <Login loginReferer={fullpath} showPanel={false} viewType={LOGIN_PAGE_TYPES.general} />
      </div>
    </div>;
};
export default CreativeModalLogin;